import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { Nullable } from 'cng-common/models/utils'
import { IForm } from 'core-components/classes/models/IForm'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { IPartner } from '../models'

import { mapPartnerFromPartnerAllDataRegions } from './mapping/mapPartnerFromPartnerAllDataRegions'

export const fetchPartnerRequestById = async (
  partnerId: string,
  options?: ICrudFetchOptions
): Promise<Nullable<IPartner>> => {
  const partnerCrud = CrudStore.get(CrudStoreItem.PartnerAllData, options?.cacheKey)
  return partnerCrud
    .getById({ id: partnerId, force: options?.isForce, keyField: 'PartnerID' })
    .then((result: IForm) => {
      if (result) {
        return mapPartnerFromPartnerAllDataRegions(result)
      }

      return null
    })
    .catch((err) => {
      Logger.error(err)
      return null
    })
}
